<template>
  <div class="row">
    <div class="col-md-12">
      <management-my-orders-suppliers-form :route="route" @on-submit="onPageSubmit"></management-my-orders-suppliers-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import ManagementMyOrdersSuppliersForm from './ManagementMyOrdersSuppliersForm.vue'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      ManagementMyOrdersSuppliersForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        pageModel: {},
        page: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onPageSubmit (model, isValid) {
        this.pageModel = model
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Suppliers/ManagementMyOrdersSuppliersAdd.vue